import React from 'react'
import LayoutContainer from 'components/Common/LayoutContainer'
import Heading from 'LuxKit/Typography/Heading'
import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'
import FullWidthCarousel from 'LuxKit/Carousel/FullWidthCarousel'
import HotelPageSearchHotelCategoryTile from './HotelPageSearchHotelCategoryTile'
import { CategoryData } from './types'
import styled from 'styled-components'
import { rem } from 'polished'

const Root = styled.div`
  padding-top: ${rem(40)};
  padding-bottom: ${rem(40)};
`

const categories: Array<CategoryData> = [
  {
    id: 'city_break',
    name: 'City breaks',
    imageId: 'hotel-category-tile-city-break',
    show: true,
    parameterName: 'holidayTypes',
    parameterValue: 'City Break',
  },
  {
    id: 'sun_beach',
    name: 'Sun & Beach',
    imageId: 'hotel-category-tile-sun-beach',
    show: true,
    parameterName: 'holidayTypes',
    parameterValue: 'Sun & Beach',
  },
  {
    id: 'private_pool',
    name: 'Private pool',
    imageId: 'hotel-category-tile-private-pool',
    show: true,
    parameterName: 'amenities',
    parameterValue: 'Private pool',
  },
  {
    id: 'unique_stays',
    name: 'Unique stays',
    imageId: 'hotel-category-unique-stays',
    show: true,
    parameterName: 'holidayTypes',
    parameterValue: 'Unique Stays',
  },
  {
    id: 'spa_break',
    name: 'Spa break',
    imageId: 'hotel-category-tile-spa-break',
    show: true,
    parameterName: 'holidayTypes',
    parameterValue: 'Spa Break',
  },
  {
    id: 'romantic',
    name: 'Romantic',
    imageId: 'hotel-category-tile-romantic-2',
    show: true,
    parameterName: 'holidayTypes',
    parameterValue: 'Romantic',
  },
  {
    id: 'boutique',
    name: 'Boutique',
    imageId: 'hotel-category-tile-boutique',
    show: true,
    parameterName: 'holidayTypes',
    parameterValue: 'Boutique',
  },
]

function HotelPageDestinationTiles() {
  return (
    <Root>
      <VerticalSpacer gap={20}>
        <LayoutContainer>
          <Heading variant="heading2">
            <>Discover <i>your</i> ideal escape</>
          </Heading>
        </LayoutContainer>
        <FullWidthCarousel snap="start" itemsPerArrow={6}>
          {categories.map(category => {
            return <HotelPageSearchHotelCategoryTile key={category.id} category={category} />
          })}
        </FullWidthCarousel>
      </VerticalSpacer>
    </Root>
  )
}

export default HotelPageDestinationTiles
